"use strict";

exports.__esModule = true;
exports.default = void 0;
var _createReduce = _interopRequireDefault(require("./_createReduce.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
var _default = exports.default = (0, _createReduce.default)(1);